'use client';

import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import type { ParagraphMeta } from '../../../interfaces';
import { VideoConsentOverlay } from '../VideoConsentOverlay/VideoConsentOverlay.client';

export type VideoType = ParagraphMeta & {
  type: 'video_youtube';
  field_margin?: string;
  field_video_autoplay: boolean;
  field_video_id: string;
};

export const Video = ({ data }: { data: VideoType }) => {
  const config = useConfig();
  const {
    type,
    field_margin: margin,
    field_video_id: videoId,
    field_video_autoplay: autoplay,
  } = data;

  const { url, name, provider } = config.video[type];

  const iframeUrl = url.replace('<id>', videoId).replace('<autoplay>', autoplay ? '1' : '0');

  return (
    <div
      className="relative pb-[56.25%] [&_iframe]:absolute [&_iframe]:top-0 [&_iframe]:left-0 [&_iframe]:size-full [&_iframe]:overflow-hidden [&_iframe]:border-0"
      style={{ margin }}
    >
      <VideoConsentOverlay
        sessionStorageKey={`hasSeenOverlay${type}`}
        texts={{ provider, providerName: name }}
      >
        <iframe title={videoId} src={iframeUrl} allowFullScreen />
      </VideoConsentOverlay>
    </div>
  );
};
